import FieldDefs from './ConcurentPagesFieldDefs'
import ConcPagesAction from '../../component/ks-table/component/conc-pages-action.vue'
import {doLangFields} from '../../lib/ks-tools'

export default {
    template: `<div><slot v-bind="self"/></div>`,
    data () {
        return {
            fields: doLangFields(this, "lang.report.concurentpages", FieldDefs),
            sortOrder: [
                {
                    field: 'cnt',
                    direction: 'desc'
                }
            ],
            moreParams: {}
        }
    },
    computed: {
        self() {
            return this;
        },
    },
    components: {
        ConcPagesAction
    },
}
